
export const getThemeProperty = (propertyKey) => {
    return getComputedStyle(document.documentElement).getPropertyValue(propertyKey);   
}

function hexToRgbA(hex, opacity) {
    let temp;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        temp= hex.substring(1).split('');
        if(temp.length== 3){
            temp= [temp[0], temp[0], temp[1], temp[1], temp[2], temp[2]];
        }
        temp= `0x${temp.join('')}`;
        return `rgba(${[(temp>>16)&255, (temp>>8)&255, temp&255].join(',')}, ${opacity})`;
    }
    throw new Error('Bad Hex');
}

const SetTheme = (themeJSON) => {
    const bodyStyles = document.body.style;  
    
    for (let property in themeJSON) {
        if(property === "--button-bg-color") {
            bodyStyles.setProperty("--home-bottom-img-fill1", hexToRgbA(themeJSON[property], 0.03));
            bodyStyles.setProperty("--home-bottom-img-fill2", hexToRgbA(themeJSON[property], 0.03));
            bodyStyles.setProperty("--button-hover-color", hexToRgbA(themeJSON[property], 0.10));
            bodyStyles.setProperty("--button-primary-hover", hexToRgbA(themeJSON[property], 0.90));
        }
        if(property.includes("url")) {
            bodyStyles.setProperty(property, `url(${themeJSON[property]})`);
        } else {
            bodyStyles.setProperty(property, themeJSON[property]);
        }
    }  
}

export default SetTheme;